import React from 'react'

// components
import {
  CCol,
  CFormLabel,
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormPhoneNumber from '../general-input-form/FormPhoneNumber'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormFileUpload from '../general-input-form/FormFileUpload'
import FormImageThumbnail from '../general-input-form/FormImageThumbnail'
import FormFileThumbnail from '../general-input-form/FormFileThumbnail'
import FormOtherPIC from '../general-input-form/FormOtherPic'
import FormClientAdditionalAddress from '../general-input-form/FormClientAdditionalAddress'
import FormSelectInput from '../general-input-form/FormSelectInput'
import { getFileType } from 'src/helpers/get-file-type'

const AppForm = ({
  values,
  handleChange,
  countryOptions,
  provinceOptions,
  cityOptions,
  districtOptions,
  subDistrictOptions,
  countryPhone,
  countryValue,
  provincedValue,
  cityValue,
  districtValue,
  subDistrictValue,
  setCountryPhone,
  handleSelectCountryPhone,
  handleSelectCountry,
  handleSelectProvince,
  handleSelectCity,
  handleSelectDistrict,
  handleSelectSubDistrict,
  errors,
  handleRemoveImage,
  handleFileInput,
  handleFileOnDrop,
  setOpenFilePreview,
  editPage,
  handleAddOthersPIC,
  handleChangeOthersPIC,
  handleSelectCountryOthersPIC,
  handleRemoveOthersPIC,
  handleAddAdditionalAddress,
  handleRemoveAdditionalAddress,
  handleChangeAdditionalAddress,
  handleSelectAreaAdditionalAddress
}) => {
  let fileType = ''
  if (values.npwp_image?.length > 0) {
    if (values.npwp_image[0]?.name) {
      fileType = getFileType(values.npwp_image[0]?.name)
    } else if (values.npwp_image[0]?.file_original_name) {
      fileType = getFileType(values.npwp_image[0]?.file_original_name)
    } else {
      fileType = getFileType(values.npwp_image[0])
    }
  }
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='client_name'
          name='client_name'
          colSize='6'
          inputLabel='Client Name'
          className='mb-3'
          placeholder='Enter client name...'
          value={values.client_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.client_name}
          invalid={errors.client_name}
          autoFocus={true}
        />
        <FormTextInput 
          id='client_description'
          name='client_description'
          colSize='6'
          inputLabel='Client Description'
          className='mb-3'
          placeholder='Enter client description...'
          value={values.client_description}
          handleTextInput={handleChange}
          feedbackInvalid={errors.client_description}
          invalid={errors.client_description}
        />
        <FormTextAreaInput
          id='client_address'
          name='client_address'
          colSize='6'
          inputLabel='Client Address'
          className='mb-3'
          placeholder='Enter client address...'
          rows='10'
          value={values.client_address}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors.client_address}
          invalid={errors.client_address}
        />
        {values.npwp_image.length > 0 ? fileType && fileType == 'image' ? (
          <FormImageThumbnail
            editPage={editPage}
            inputLabel='Document NPWP'
            name='npwp_image'
            colSize='6'
            productImages={values.npwp_image}
            handleChangeImage={handleFileInput}
            handleRemoveImage={handleRemoveImage}
            setOpenFilePreview={setOpenFilePreview}
          />
        ) : (
          <CCol lg={6}>
            <CFormLabel>
              Document NPWP
            </CFormLabel>
            <FormFileThumbnail 
              name='npwp_image'
              colSize='6'
              files={values.npwp_image}
              className='justify-content-start align-items-center'
              handleViewFile={setOpenFilePreview}
              handleConfirmDelete={handleRemoveImage}
            />
          </CCol>
        ) : (
          <FormFileUpload
            name='npwp_image'
            colSize='6'
            inputLabel='Document NPWP'
            handleFileInput={handleFileInput}
            handleFileOnDrop={handleFileOnDrop}
            multiple={false}
            invalid={errors.npwp_image}
            feedbackInvalid={errors.npwp_image}
            maxFiles={1}
          />
        )}
        <FormSelectInput 
          id='client_country_id'
          name='client_country_id'
          colSize='6'
          inputLabel='Country'
          className='mb-3'
          selectOptions={countryOptions}
          value={countryValue}
          handleSelectInput={handleSelectCountry}
          feedbackInvalid={errors.client_country_id}
          invalid={errors.client_country_id}
          disabled={false}
          placeholder='Please select country...'
        />
        {
          countryValue && countryValue?.label?.includes('Indonesia') && (
            <>
              <FormSelectInput 
                id='client_province_id'
                name='client_province_id'
                colSize='6'
                inputLabel='Province'
                className='mb-3'
                selectOptions={provinceOptions}
                value={provincedValue}
                handleSelectInput={handleSelectProvince}
                feedbackInvalid={errors.client_province_id}
                invalid={errors.client_province_id}
                disabled={false}
                placeholder='Please select province...'
              />
              <FormSelectInput 
                id='client_city_id'
                name='client_city_id'
                colSize='6'
                inputLabel='City'
                className='mb-3'
                selectOptions={cityOptions}
                value={cityValue}
                handleSelectInput={handleSelectCity}
                feedbackInvalid={errors.client_city_id}
                invalid={errors.client_city_id}
                disabled={false}
                placeholder='Please select city...'
              />
              <FormSelectInput 
                id='client_district_id'
                name='client_district_id'
                colSize='6'
                inputLabel='District'
                className='mb-3'
                selectOptions={districtOptions}
                value={districtValue}
                handleSelectInput={handleSelectDistrict}
                feedbackInvalid={errors.client_district_id}
                invalid={errors.client_district_id}
                disabled={false}
                placeholder='Please select district...'
              />
              <FormSelectInput 
                id='client_subdistrict_id'
                name='client_subdistrict_id'
                colSize='6'
                inputLabel='Sub District'
                className='mb-3'
                selectOptions={subDistrictOptions}
                value={subDistrictValue}
                handleSelectInput={handleSelectSubDistrict}
                feedbackInvalid={errors.client_subdistrict_id}
                invalid={errors.client_subdistrict_id}
                disabled={false}
                placeholder='Please select subdistrict...'
              />
              <FormTextInput 
                id='client_postal_code'
                name='client_postal_code'
                colSize='6'
                inputLabel='Postal Code'
                className='mb-3'
                placeholder='Enter postal code...'
                value={values.client_postal_code}
                handleTextInput={handleChange}
                feedbackInvalid={errors.client_postal_code}
                invalid={errors.client_postal_code}
              />
            </>
          )
        }
      </CRow>
      <CRow className="mb-4">
        <FormTextInput 
          id='pic_name'
          name='pic_name'
          colSize='6'
          inputLabel='Point of Contact (PoC) Name'
          className='mb-3'
          placeholder='Enter point of contact name...'
          value={values.pic_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.pic_name}
          invalid={errors.pic_name}
          handleClickButton={handleAddOthersPIC}
          isShowButton={true}
          buttonLabel={'Add More'}
        />
        <FormPhoneNumber
          colSize='6'
          inputLabel='Point of Contact (PoC) Phone Number'
          placeholder='Enter point of contact phone number...'
          className='mb-3'
          countryOptions={countryOptions}
          country={countryPhone}
          setCountry={setCountryPhone}
          value={values}
          handlePhoneNumber={handleChange}
          handlePhoneCountry={handleSelectCountryPhone}
          errors={errors}
        />
        <FormTextInput 
          id='pic_job_position'
          name='pic_job_position'
          colSize='6'
          inputLabel='Point of Contact (PoC) Job Position'
          className='mb-3'
          placeholder='Enter point of contact job position...'
          value={values.pic_job_position}
          handleTextInput={handleChange}
          feedbackInvalid={errors.pic_job_position}
          invalid={errors.pic_job_position}
          handleClickButton={handleAddOthersPIC}
        />
        <FormTextInput 
          id='pic_email_address'
          name='pic_email_address'
          colSize='6'
          inputLabel='Point of Contact (PoC) Email Address'
          className='mb-3'
          placeholder='Enter point of contact email address...'
          value={values.pic_email_address}
          handleTextInput={handleChange}
          feedbackInvalid={errors.pic_email_address}
          invalid={errors.pic_email_address}
          handleClickButton={handleAddOthersPIC}
        />
        <FormTextInput 
          id='pic_department'
          name='pic_department'
          colSize='6'
          inputLabel='Point of Contact (PoC) Department/Division'
          className='mb-3'
          placeholder='Enter point of contact department/division...'
          value={values.pic_department}
          handleTextInput={handleChange}
          feedbackInvalid={errors.pic_department}
          invalid={errors.pic_department}
          handleClickButton={handleAddOthersPIC}
        />
        <FormTextAreaInput
          id='pic_additional_notes'
          name='pic_additional_notes'
          colSize='6'
          inputLabel='Point of Contact (PoC) Additional Notes'
          className='mb-3'
          placeholder='Enter point of contact additional notes...'
          rows='5'
          value={values.pic_additional_notes}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors.pic_additional_notes}
          invalid={errors.pic_additional_notes}
        />
      </CRow>
      <FormOtherPIC 
        inputLabel={'Other Point of Contact (PoC)'}
        className={'mb-5'}
        othersPIC={values.others_pic}
        countryOptions={countryOptions}
        errors={errors}
        handleChange={handleChangeOthersPIC}
        handlePhoneCountry={handleSelectCountryOthersPIC}
        handleRemoveOthersPIC={handleRemoveOthersPIC}
      />
      <FormClientAdditionalAddress 
        inputLabel={'Additional Client Address'}
        className={'mb-5'}
        additional_address={values.additional_address}
        countryOptions={countryOptions}
        provinceOptions={provinceOptions}
        errors={errors}
        handleAddAdditionalAddress={handleAddAdditionalAddress}
        handleChange={handleChangeAdditionalAddress}
        handleRemoveAdditionalAddress={handleRemoveAdditionalAddress}
        handleSelectInputArea={handleSelectAreaAdditionalAddress}
      />
    </>
  )
}

export default AppForm